import { SvgIcon } from '@mui/material';
import { ReactComponent as WalletSVG } from "./wallet-sc.svg";

export default function IconIOSWalletSC(props) {
  return <SvgIcon {...props} component={WalletSVG} viewBox="0 0 94 34" />;
}